<template>
  <form-group class="ma-0 pa-0">
    <v-row>
      <v-col cols="12">
        <v-row justify="start">
          <v-col cols="6">
            <v-checkbox
              id="input:sendSms"
              :value="!sendSms"
              label="Não quero enviar SMS"
              @change="v => handleSendSms(!v)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              id="input:bodySms"
              ref="bodySms"
              v-model="payload.body"
              :loading="loading"
              label="Mensagem do SMS"
              v-bind="required([maxLength(160)])"
              rows="6"
              counter="160"
              outlined
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'NotificationSmsContent',
  components: { FormGroup },
  mixins: [RulesMixin],
  computed: {
    payload() {
      return this.notification.payload.sms;
    },
    sendSms() {
      return this.notification.payload.sendSms;
    },
    required() {
      return (rules = []) => (
        this.sendSms
          ? {
            required: true,
            rules: [this.requiredRule, ...rules],
          }
          : {});
    },
    handleSendSms() {
      return (bool) => this.handleSelectedMessage('sendSms', bool);
    },
    loading() {
      return this.notification.loading;
    },
  },
  inject: {
    notification: {
      default() {
        return {
          payload: {
            sms: {
              body: '',
              communicationId: '',
              isDraft: false,
              id: '',
            },
            sendSms: '',
          },
          loading: '',
        };
      },
    },
    handleSelectedMessage: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
